import React, { useEffect, useCallback, useState} from 'react';
import {useContainerCoords} from "components/hooks/useContainerCoords.js"
import {connect} from 'react-redux';
import {setSelectedPulledElements} from 'actions/index.js';

const PulledBackground = ({
    isSubPatch,
    setSelectedPulledElements,
    getSelection,
    editorRef,
    scale,
    onMouseMove,
    sequencerEngine,
    dropdownPos,
    setSelectedZObject,
    getXY
}) => { 
    let [selection, setSelection] = useState(undefined);

    const _onMouseMove = useCallback((e) => {
        onMouseMove(e);
        if (selection) {
            let {x,y} = getXY(e, true);
            let editorPadding = sequencerEngine.state.spatial.editorPadding;
            //x -= Math.max(0, editorPadding.x);
            //y -= Math.max(0, editorPadding.y);
            setSelection({...selection, x2: x, y2: y});
        }
    }, [selection, setSelection, scale, sequencerEngine, getXY]);

    const onMouseDown = useCallback((e) => {
        if (e.which === 3) {
            return;
        }
        if (e.target.className.baseVal === "edges-drawer" || 
             (e.target.className.includes && (e.target.className.includes("pulled-background")  ||
                                              e.target.className.includes("grids-inner")))
        ) {
        } else {
            return;
            // its not the background
        }
        if (sequencerEngine.state.spatial.showPadSequencer) {
            return;
        }
        let {x,y} = getXY(e, true);
        let editorPadding = sequencerEngine.state.spatial.editorPadding;
        //x -= Math.max(0, editorPadding.x);
        //y -= Math.max(0, editorPadding.y);
        setSelection({x1: x, y1: y, x2: x, y2: y});
    }, [setSelection, sequencerEngine, getXY]);

    const onMouseUp = useCallback((e) => {
        if (dropdownPos) {
            return;
        }

        if (sequencerEngine.state.spatial.showPadSequencer) {
            return;
        }

        let editorPadding = sequencerEngine.state.spatial.editorPadding;
        if (selection && selection.x2 - selection.x1 > 1) {
            let scale = window._scale || 1;
            let _selection = isSubPatch ? selection : {
                x1: (selection.x1 - Math.max(0, editorPadding.x)) / scale,
                y1: (selection.y1 - Math.max(0, editorPadding.y)) / scale,
                x2: (selection.x2 - Math.max(0, editorPadding.x)) / scale,
                y2: (selection.y2 - Math.max(0, editorPadding.y)) / scale,
            };
            let selectedElements = getSelection(_selection);
            let x = {};
            let backgroundId = sequencerEngine.state.zobjectBackground &&
                sequencerEngine.state.zobjectBackground.id;
            for (let {id} of selectedElements) {
                if (id === backgroundId) {
                    continue;
                } else {
                    x[id] = true;
                }
            }
            setSelectedPulledElements(x);
            setSelectedZObject(undefined);
            setSelection(undefined);
            return;
        }
        if (selection) {
            setSelectedPulledElements({});
            setSelection(undefined);
            setSelectedZObject(undefined);
        }
    }, [selection, setSelection, dropdownPos, sequencerEngine, getXY]);

    useEffect(() => {
        if (!editorRef.current) {
            return undefined;
        }
        editorRef.current.addEventListener("mousedown", onMouseDown);
        editorRef.current.addEventListener("mouseup", onMouseUp);
        editorRef.current.addEventListener("mousemove", _onMouseMove);

        return () => {
            if (!editorRef.current) {
                return undefined;
            }
            editorRef.current.removeEventListener("mousedown", onMouseDown);
            editorRef.current.removeEventListener("mouseup", onMouseUp);
            editorRef.current.removeEventListener("mousemove", _onMouseMove);
        };
    }, [selection, setSelection, dropdownPos, sequencerEngine, getXY]);
    
    return (
        <div
          className="pulled-background">
          {selection && selection.x2 - selection.x1 > 0 &&
           <div
           style={{
               left: selection.x1 ,
               top: selection.y1 ,
               width: selection.x2 - selection.x1,
               height: selection.y2 - selection.y1,
           }}
             className="selection"/>}
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSelectedPulledElements: x => dispatch(
          setSelectedPulledElements(x))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PulledBackground);
